module.exports = __webpack_public_path__ + "static/media/toolbar-select.cc0c646e.svg";